import React from 'react'
import { cn } from '../lib/util.ts'
import { TMessage } from '../types/TMessage.tsx'


export function ChatMessage(msg: TMessage) {
  return (
    <div
      className={cn(
        'flex mb-4',
        msg.sender === 'Anne' ? 'justify-end' : 'justify-start'
      )}
    >
      <div
        className={cn(
          'max-w-[70%] rounded-2xl p-3 relative',
          msg.sender === 'Anne' ? 'bg-[#dcf8c6] rounded-tr-none' : 'bg-white rounded-tl-none'
        )}
      >
        <span className={cn(
          'text-xs font-semibold mb-1 block',
          msg.sender === 'Anne' ? 'text-green-700' : 'text-blue-600'
        )}>
          {msg.sender}
        </span>
        <p className="text-sm text-gray-800 mb-1">{msg.message}</p>
        {msg.attachment && msg.attachment.extension === 'jpg ' && (
          <div className="mt-2 rounded-lg overflow-hidden">
            <img src={`media/${msg.attachment.fileName}`} alt="Attachment" width={200} height={200} className="w-full h-auto" />
          </div>
        )}
        {msg.attachment && msg.attachment.extension === 'mp4 ' && (
          <div className="mt-2 rounded-lg overflow-hidden">
            <video controls className="w-full h-auto max-h-[200px]">
                <source src={`media/${msg.attachment.fileName}`} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
          </div>
        )}
        <span className="text-xs text-gray-500 block text-right mt-1">{msg.timestamp}</span>
        <div
          className={cn(
            'absolute top-0 w-4 h-4',
            msg.sender === 'Anne' ? '-right-2 bg-[#dcf8c6]' : '-left-2 bg-white'
          )}
          style={{
            clipPath: msg.sender === 'Anne' ? 'polygon(0 0, 0% 100%, 100% 0)' : 'polygon(100% 0, 0 0, 100% 100%)'
          }}
        />
      </div>
    </div>
  )
}

